module.exports = __webpack_public_path__ + "img/2_39.a4531ef3.png";